function stopAudio() {
	var playpausebutton = document.getElementsByClassName('fa fa-pause');
	var overlays = document.getElementsByClassName('overlay playing');
	for(i=0; i<overlays.length; i++) overlays[i].className = "overlay";
	for(i=0; i<playpausebutton.length; i++) playpausebutton[i].className = "fa fa-play";
}

function stopAudioFrontPage() {
	var players = document.getElementsByClassName('sample-player');
	var playpausebutton = document.getElementsByClassName('pause');
	for(i=0; i<players.length; i++) players[i].pause();
	for(i=0; i<playpausebutton.length; i++) playpausebutton[i].className = "play-btn";
}

function playPlaylistSample() {
	var audio = document.getElementById('widget-audioarea');
	audio.load();
	audio.play();
}
















function kksInitProgressBar(prefix) {
	var player = document.getElementById(prefix + '-player');
	var length = player.duration
	var current_time = player.currentTime;

	var totalLength = kksCalculateTotalValue(length)
	var currentTime = kksCalculateCurrentValue(current_time);

	var parent = jQuery('#' + prefix + '-audio-player')
	parent.find('.start-time').html(currentTime);
	parent.find('.end-time').html(totalLength);


	//<progress>
	var progressbar = document.getElementById(prefix + '-seekObj');
	if(isNaN(player.duration)) {
		progressbar.value = 0;
	} else {
		progressbar.value = (player.currentTime / player.duration);
	}
	progressbar.addEventListener('click', seek);

	//input[type=range]
	var newProgressBar = document.getElementById(prefix + '-progress-bar');
	if(isNaN(player.duration)) {
		newProgressBar.value = 0;
	} else {
		newProgressBar.value = (player.currentTime / player.duration);
	}
	newProgressBar.addEventListener('click', seek);


	if(player.currentTime == player.duration) {
		parent.find('.play-btn').removeClass('pause');
		progressbar.value = 0;
		newProgressBar.value = 0;
	}

	function seek(evt) {
		var percent = evt.offsetX / this.offsetWidth;
		player.currentTime = percent * player.duration;
		progressbar.value = percent / 100;
	}
};

function kksCalculateTotalValue(length) {
	var minutes = Math.floor(length / 60);
	var seconds_int = Math.floor(length - minutes * 60);
	var seconds_str = seconds_int.toString();
	var seconds = seconds_str.substr(0, 2);
	if(seconds.length == 1) {
		seconds = '0' + seconds;
	}
	var time = minutes + ':' + seconds;

	if(time == 'NaN:Na') {
		time = '0:00';
	}

	return time;
}

function kksCalculateCurrentValue(currentTime) {
	var current_hour = parseInt(currentTime / 3600) % 24,
	current_minute = parseInt(currentTime / 60) % 60,
	current_seconds_long = Math.floor(currentTime % 60),
	current_seconds = current_seconds_long.toFixed(),
	current_time = (current_minute < 10 ? current_minute : current_minute) + ":" + (current_seconds < 10 ? "0" + current_seconds : current_seconds);

	return current_time;
}



function togglePlay(player, parent) {
	playBtn = parent.find('.play-btn');
	wasPaused = playBtn.hasClass('pause');
	stopAudioFrontPage();
	if(wasPaused) {
		player.pause();
		isPlaying = false;
		playBtn.removeClass('pause');
	} else {
		player.play();
		isPlaying = true;
		playBtn.addClass('pause');
	}
	return isPlaying;
}





jQuery(function($) {
	$('.sample-player').each(function(){
		var player = document.getElementById($(this).attr('id'));
		player.load();
	});

	// $('.play-btn').on('click', function(){
	// 	var parent = $(this).closest('.player-wrapper');
	// 	var playerId = parent.find('.sample-player').attr('id');
	// 	var player = document.getElementById(playerId);
	// 	togglePlay(player, parent);
	// });

	$('.track-list .samples').on('click', function(){
		stopAudioFrontPage();
		var parent = $(this).closest('.player-wrapper');

		var trackNumber = $(this).attr('track_number');

		var changeTrack = parent.find('.audio-sample-list .track[track_number=' + trackNumber + ']');
		var activeTrack = parent.find('.audio-sample-list .track.active');

		updateTrackInfo(changeTrack, activeTrack, parent);
	});

	$('.player-controls .seek').on('click', function(){
		stopAudioFrontPage();
		var parent = $(this).closest('.player-wrapper');
		var direction = $(this).hasClass('fwd') ? 'fwd' : 'rev';
		changeFrontPagePlayerTrack(direction, parent);
	});

	function changeFrontPagePlayerTrack(direction, parent) {
		var sampleList = parent.find('.audio-sample-list');
		var activeTrack = parent.find('.audio-sample-list .track.active');
		var sampleListTracks = sampleList.find('.track');
		var changeTrack;
		if(direction == 'rev') {
			changeTrack = activeTrack.prev();
			if(changeTrack.length == 0) changeTrack = $(sampleListTracks[sampleListTracks.length - 1]);
		} else if(direction == 'fwd') {
			changeTrack = activeTrack.next();
			if(changeTrack.length == 0) changeTrack = $(sampleListTracks[0]);
		}

		updateTrackInfo(changeTrack, activeTrack, parent);
	}

	function updateTrackInfo(changeTrack, activeTrack, parent) {
		var trackNumber = changeTrack.attr('track_number');
		var playerId = parent.find('.sample-player').attr('id');
		if(trackNumber !== undefined) {
			if(trackNumber.length > 0) {
				$(".track-list .samples").removeClass('active-sample');
				var trackListing = parent.find('.track-list .samples[track_number=' + trackNumber + ']');
				trackListing.addClass('active-sample');
			}
		}

		activeTrack.removeClass('active');
		changeTrack.addClass('active');
		parent.find('.sample-track-title').html(changeTrack.html());
		parent.find('.sample-track-permalink').attr('href', changeTrack.attr('permalink'));
		parent.find('.sample-track-arranger-name').html(changeTrack.attr('arranger'));
		parent.find('.audiomp3').attr('src', changeTrack.attr('sample_mp3'));

		var player = document.getElementById(playerId);
		player.load();

		// togglePlay(player, parent);
		playPause();
	}
});

